import { render, staticRenderFns } from "./UmyIcon.vue?vue&type=template&id=7cb959d0&scoped=true&"
import script from "./UmyIcon.vue?vue&type=script&lang=js&"
export * from "./UmyIcon.vue?vue&type=script&lang=js&"
import style0 from "./UmyIcon.vue?vue&type=style&index=0&id=7cb959d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb959d0",
  null
  
)

export default component.exports